import { Component } from '@angular/core';
import { Injectable } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Filterbox } from '../filterbox.service';


@Component({
  selector: 'filterbox-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./filterbox.component.css'],
  providers: [ Filterbox ]
})
@Injectable({
  providedIn: 'root'
})
export class GroupComponent {
  private groupsList = [];


  constructor(private filterboxService : Filterbox) {
    filterboxService.getGroups().then((data) => {
      this.groupsList = data;
    });
  }


}
